var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.versionMobile)?_c('div',{staticClass:"carousel-featured hide-for-print"},[_c('div',{staticClass:"carousel-mobile-version"},[_vm._t("default")],2)]):_c('div',[_c('carousel',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }